import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ErrorMessage, StyledInput } from './BaseInput';
import { colorFieldsBorder, colorAccent, colorBackgroundBody, colorText } from '../../theme/palette';

const normalizeUrl = (value) => {
  const text = String(value || '').trim();
  if (!text) return '';
  if (/^https?:\/\//i.test(text)) return text;
  return `https://${text}`;
};

const copyToClipboard = async (text) => {
  if (!text) return;

  if (navigator?.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
};

const UrlActionField = ({ name, placeholder, value, input, meta, error }) => {
  const fieldValue = input ? input.value : value;
  const fieldName = input ? input.name : name;
  const rawUrl = String(fieldValue || '');
  const normalizedUrl = normalizeUrl(rawUrl);
  const hasUrl = !!normalizedUrl;

  const handleOpen = () => {
    if (!hasUrl) return;
    window.open(normalizedUrl, '_blank', 'noopener,noreferrer');
  };

  const handleCopy = async () => {
    if (!hasUrl) return;
    await copyToClipboard(rawUrl.trim());
  };

  return (
    <FieldWrap>
      <InputActionsWrap>
        <StyledInput
          name={fieldName}
          type="text"
          value={rawUrl}
          readOnly
          placeholder={placeholder}
          onClick={handleOpen}
          style={{ cursor: hasUrl ? 'pointer' : 'default', background: colorBackgroundBody }}
          title={hasUrl ? 'Clique para abrir a URL em nova aba' : 'Sem URL informada'}
        />
        <ActionButton type="button" onClick={handleOpen} disabled={!hasUrl} title="Abrir URL">
          Abrir
        </ActionButton>
        <ActionButton type="button" onClick={handleCopy} disabled={!hasUrl} title="Copiar URL">
          Copiar
        </ActionButton>
      </InputActionsWrap>
      {(error || (meta && meta.touched && meta.error)) && <ErrorMessage>{error || meta.error}</ErrorMessage>}
    </FieldWrap>
  );
};

UrlActionField.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  input: PropTypes.object,
  meta: PropTypes.object,
  error: PropTypes.string,
};

export default UrlActionField;

const FieldWrap = styled.div`
  width: 100%;
`;

const InputActionsWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;

  ${StyledInput} {
    flex: 1 1 auto;
    min-width: 0;
  }
`;

const ActionButton = styled.button`
  height: 32px;
  border: 1px solid ${colorFieldsBorder};
  border-left: 0;
  background: #fff;
  color: ${colorText};
  padding: 0 10px;
  font-size: 12px;
  cursor: pointer;

  &:hover:not(:disabled) {
    color: ${colorAccent};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
